<div class="updates-content">
  <h1>Product Updates</h1>
  <mat-list>
    @for (item of productUpdates$ | async; track item.summary) {
      <mat-list-item>
        @if (item.summary) {
          <p mat-line class="title">
            {{ item.summary }}
            @if (item.isNew) {
              <span class="new">NEW</span>
            }
          </p>
        }
        @if (item.date) {
          <p mat-line class="date">{{ item.date | dateFormat }}</p>
        }
        @if (item.preview) {
          <p mat-line [innerHTML]="item.preview | safeHtml"></p>
        }
      </mat-list-item>
    }
  </mat-list>
</div>
